import React from "react";
import PropTypes from "prop-types";

const MissingPersonImgWeb = React.lazy(() => import('./MissingPersonImgWeb'));

const MissingPersonImg = ({ format = 'WEB', ...props }) => {
  const fallback = <div style={{ width: '170px', height: '45px', backgroundColor: '#f0f0f0' }}></div>;
  
  return (
    <React.Suspense fallback={fallback}>
      {format === 'WEB' && <MissingPersonImgWeb {...props} />}
    </React.Suspense>
  );
};

MissingPersonImg.propTypes = {
    format: PropTypes.oneOf(['WEB', 'PDF', 'PNG']),
    ruta_foto: PropTypes.string.isRequired,
    alt_text: PropTypes.string.isRequired,
    isMobile: PropTypes.bool,
};

export default MissingPersonImg;
